import { ApprovalStatusType } from "../../domain/model/approval-status-type";
import { Uuid } from "../../domain/model/uuid/uuid.type";
import { UserInfoViewModel } from "./user-info.viewmodel";


export class ApprovalStatusViewModel {
  constructor(
    readonly id: Uuid,
    readonly time: Date,
    readonly user: UserInfoViewModel,
    readonly status: ApprovalStatusType) {
  }

  toString(): string {
    return `Id: ${this.id}, Time: ${this.time}, User: ${this.user}, Status: ${this.status}`;
  }
}
